const Circle = () => (
    <img
        src="/assets/img/circle.svg"
        alt="bullet"
        className="me-2 mt-2"
        width={10}
        height={10}
    />
);

export default Circle;